function showPropertyDescription(propertyId) {
    $("#property-description-" + propertyId).removeClass("translucent");
    $("#show-more-link-" + propertyId).hide();
    $("#hide-more-link-" + propertyId).show();
}

function hidePropertyDescription(propertyId) {
    $("#property-description-" + propertyId).addClass("translucent");
    $("#show-more-link-" + propertyId).show();
    $("#hide-more-link-" + propertyId).hide();
}